import { Directive } from '@angular/core';
import { SessionManager } from 'src/app/managers/session/session.manager';
import { isSessionCode } from 'src/app/enums/session/session-code.enum';
import { Router } from '@angular/router';
import { RoutingPages } from 'src/app/enums/routing/routing-pages.enum';

@Directive({
  selector: '[autoLogin]'
})
export class AutoLoginDirective {

  constructor( 
    private _session: SessionManager,
    private _router : Router
  ) {
    this.checkIfLogged()
  }

  checkIfLogged () 
  {
    let user = this._session.user().get()

    if (!isSessionCode(user)) {
      this._router.navigate ( [`${RoutingPages.MAIN}/${RoutingPages.DASHBOARD}`] )
    }
  }
}
